import * as React from "react";
const SvgCanva = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Canva_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 10,
  fill: "url(#Canva_svg__b)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: 0.115,
  d: "M11.469 18.429a5 5 0 0 1-1.697-.394 5 5 0 0 1-.499-.256 4.45 4.45 0 0 1-1.383-1.335 4 4 0 0 1-.164-.261 5.7 5.7 0 0 1-.637-1.71 6.7 6.7 0 0 1-.145-1.37c-.014-.881.066-1.571.276-2.378.12-.456.37-1.14.503-1.37l.116-.22a7.3 7.3 0 0 1 .902-1.36 6.46 6.46 0 0 1 2.663-1.882c.113-.05.531-.171.732-.212a5 5 0 0 1 1.156-.118c.386 0 .627.02.946.08.757.14 1.377.46 1.773.913a2.2 2.2 0 0 1 .411.703l.027.089c.005.014.017.06.026.104l.027.12c.03.128.04.477.02.674a3 3 0 0 1-.104.514c-.037.143-.1.289-.234.553-.025.05-.15.237-.211.318-.068.09-.276.297-.38.38-.121.095-.172.13-.271.182q-.382.202-.716.186c-.163-.01-.24-.045-.284-.131a.3.3 0 0 1-.027-.205c.017-.121.047-.197.194-.486.286-.563.382-.865.425-1.334a2.1 2.1 0 0 0-.084-.835 2 2 0 0 0-.19-.363 1.5 1.5 0 0 0-.294-.296 1.5 1.5 0 0 0-.489-.215 1.2 1.2 0 0 0-.27-.047l-.147-.011a2.986 2.986 0 0 0-1.304.296 3.8 3.8 0 0 0-.963.628c-.147.127-.38.36-.48.482a6.3 6.3 0 0 0-.811 1.227 8 8 0 0 0-.307.698 7.8 7.8 0 0 0-.4 1.496c-.142.718-.18 1.817-.09 2.507.019.14.073.459.089.522l.053.213c.073.298.199.643.335.918.174.35.376.635.635.892.212.21.351.321.563.448a3 3 0 0 0 .504.238c.241.09.52.137.86.144a3.6 3.6 0 0 0 1.32-.204l.126-.049a4.5 4.5 0 0 0 1.439-.946 7 7 0 0 0 .569-.637c.015-.018.056-.074.093-.126l.086-.12a13 13 0 0 0 .335-.537c.005-.005.045-.08.09-.166.112-.217.148-.274.196-.308.116-.084.262-.027.316.123.031.085.022.309-.02.476-.024.1-.124.386-.178.511a6 6 0 0 1-.253.493c-.26.447-.57.846-.96 1.233a5.4 5.4 0 0 1-.865.71l-.186.123c-.014.01-.064.038-.11.063l-.095.053c-.026.02-.329.164-.457.218a4.6 4.6 0 0 1-2.101.354Z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
  id: "Canva_svg__b",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "rotate(51.743 -.072 8.313)scale(19.7391)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.356,
  stopColor: "#02C1CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#752AEC"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "Canva_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M2 2h20v20H2z"
}))));
export default SvgCanva;
//# sourceMappingURL=Canva.js.map